import { StatementItemIcon } from '@/shared/assets';
import { cn } from '@/shared/lib';
import { Avatar, Button, Typography } from '@/shared/ui';

interface StatementProps {
  title: string;
  description: string;
  isHighlighted?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: VoidFunction;
}

export const Statement = ({
  title,
  description,
  onClick,
  isHighlighted,
  disabled,
  className,
}: StatementProps) => {
  return (
    <Button
      className={cn(
        'w-full justify-start gap-4 rounded-3xl !px-4 !py-3 text-start hover:bg-hover-base-300-hover disabled:opacity-50',
        { 'bg-base-50': isHighlighted },
        className,
      )}
      variant="clean"
      onClick={onClick}
      disabled={disabled}
    >
      <Avatar className="size-10 items-center justify-center rounded-full bg-base-100">
        <StatementItemIcon className="min-h-6 min-w-6" />
      </Avatar>

      <div className="flex flex-col gap-y-1">
        <Typography variant="16-r">{title}</Typography>
        <Typography variant="14-r" color="text-base-100">
          {description}
        </Typography>
      </div>
    </Button>
  );
};
